import logo from './sp_logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome to Sportlaan. Coming soon....
        </p>
      </header>
    </div>
  );
}

export default App;
